/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Team_Manager_Group_Description_PlaceholderInputs */

const en_team_manager_group_description_placeholder = /** @type {(inputs: Team_Manager_Group_Description_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Group Description`)
};

const fr_team_manager_group_description_placeholder = /** @type {(inputs: Team_Manager_Group_Description_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Description du groupe`)
};

const de_team_manager_group_description_placeholder = /** @type {(inputs: Team_Manager_Group_Description_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Gruppenbeschreibung`)
};

const it_team_manager_group_description_placeholder = /** @type {(inputs: Team_Manager_Group_Description_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Descrizione del gruppo`)
};

const ru_team_manager_group_description_placeholder = /** @type {(inputs: Team_Manager_Group_Description_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Описание группы`)
};

const es_team_manager_group_description_placeholder = /** @type {(inputs: Team_Manager_Group_Description_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Descripción del grupo`)
};

const zh_cn2_team_manager_group_description_placeholder = /** @type {(inputs: Team_Manager_Group_Description_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`组描述`)
};

const ja_team_manager_group_description_placeholder = /** @type {(inputs: Team_Manager_Group_Description_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`グループの説明`)
};

const hi_team_manager_group_description_placeholder = /** @type {(inputs: Team_Manager_Group_Description_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`समूह विवरण`)
};

const pt_pt2_team_manager_group_description_placeholder = /** @type {(inputs: Team_Manager_Group_Description_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Descrição do grupo`)
};

/**
* | output |
* | --- |
* | "Group Description" |
*
* @param {Team_Manager_Group_Description_PlaceholderInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const team_manager_group_description_placeholder = /** @type {((inputs?: Team_Manager_Group_Description_PlaceholderInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Team_Manager_Group_Description_PlaceholderInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_team_manager_group_description_placeholder(inputs)
	if (locale === "de") return de_team_manager_group_description_placeholder(inputs)
	if (locale === "it") return it_team_manager_group_description_placeholder(inputs)
	if (locale === "ru") return ru_team_manager_group_description_placeholder(inputs)
	if (locale === "es") return es_team_manager_group_description_placeholder(inputs)
	if (locale === "zh-CN") return zh_cn2_team_manager_group_description_placeholder(inputs)
	if (locale === "ja") return ja_team_manager_group_description_placeholder(inputs)
	if (locale === "hi") return hi_team_manager_group_description_placeholder(inputs)
	if (locale === "pt-PT") return pt_pt2_team_manager_group_description_placeholder(inputs)
	return en_team_manager_group_description_placeholder(inputs)
});